module.exports = __webpack_public_path__ + "static/img/UTSG老师_Tony.b221e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG老师_Tony.png
// module id = rZAn
// module chunks = 0